import * as React from 'react';

function SvgCompensatoryLeave(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			fill='none'
			{...props}>
			{/* Outer rounded box */}
			<rect
				x='4'
				y='2.5'
				width='16'
				height='19'
				rx='2.5'
				stroke='currentColor'
				strokeWidth='1.8'
			/>

			{/* Top display */}
			<rect
				x='7'
				y='6'
				width='10'
				height='4.5'
				rx='1'
				stroke='currentColor'
				strokeWidth='1.8'
			/>

			{/* Two indicators inside display */}
			<path
				d='M9 8.25h2M13 8.25h2'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
			/>

			{/* Divider */}
			<path
				d='M7 13h10'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
			/>

			{/* Bottom buttons */}
			<circle cx='8.5' cy='16.8' r='1' fill='currentColor' />
			<circle cx='12' cy='16.8' r='1' fill='currentColor' />
			<circle cx='15.5' cy='16.8' r='1' fill='currentColor' />
		</svg>
	);
}

export default SvgCompensatoryLeave;